import { Link } from "react-router-dom"

const AuthLayout = ({ children }: any) => {
  return <>
    <div className="min-h-screen flex items-center justify-center px-4 animated_new py-6">
      <div className="flex flex-col w-full max-w-md mx-auto">

        {/* Uncomment this if you want an image section for larger screens */}
        {/* <div className="hidden md:block md:w-1/2 shrink-0">
      <img
        src="/assets/img/homeimg.png"
        alt="logo"
        className="w-full h-full object-cover rounded-lg"
      />
    </div> */}

        <div className="w-full ">
          <div className="flex items-center justify-center w-full h-full">
            {children}
          </div>
        </div>
      </div>
    </div>

  </>
}

export default AuthLayout